import React, { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { Spin, Select, DatePicker, Button, Input, Empty, message } from "antd";
import { useParams } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import Table from "../../../../core/pagination/datatable";
import {
  CheckOutlined,
  CloseOutlined,
  FilterOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { BASE_CRM_URL } from "../../../components/config/config";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
// import { RELATED_TO_OPTIONS } from "../Tasks/taskApi";
// const BASE_CRM_URL = "http://192.168.1.21:3008/accumen/";

const Reports = () => {
  const { reportId } = useParams();
  const actualReportId = reportId?.split("=")[1];
  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const [reportConfig, setReportConfig] = useState(null);
  const [filterValues, setFilterValues] = useState({});
  console.log(reportConfig, "reportConfig");
  const [customers, setCustomers] = useState([]);
  const [leads, setLeads] = useState([]);

  const [relatedOptions, setRelatedOptions] = useState([]);

  const [staff, setStaff] = useState([]);

  console.log(relatedOptions, "relatedOptions");

  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [configLoading, setConfigLoading] = useState(false);

  const [searchText, setSearchText] = useState("");

  const [showFilters, setShowFilters] = useState(true);

  // DEFAULT FILTER VALUES

  const RELATED_TO_OPTIONS = [
    { value: "lead", label: "Lead" },
    { value: "customer", label: "Customer" },
    { value: "project", label: "Project" },
    { value: "invoice", label: "Invoice" },
    { value: "estimate", label: "Estimate" },
    { value: "proposal", label: "Proposal" },
    { value: "creditNote", label: "CreditNote" },
  ];

  const getDefaultFilterValues = (filters = []) => {
    const defaultValues = {};

    filters.forEach((filter) => {
      if (filter.key === "fromDate") {
        defaultValues[filter.key] = dayjs().startOf("year");
      } else if (filter.key === "toDate") {
        defaultValues[filter.key] = dayjs();
      } else {
        defaultValues[filter.key] = null;
      }
    });

    return defaultValues;
  };

  // GET REPORT CONFIG

  const getReportConfig = async () => {
    try {
      setConfigLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}reports/GetReportConfig`,
        {
          params: {
            reportId: actualReportId,
          },
        },
      );

      if (response.data?.Status) {
        const result = response.data.ResultData;

        setReportConfig(result);

        const defaultValues = getDefaultFilterValues(result?.filters || []);

        setFilterValues(defaultValues);
      } else {
        setReportConfig(null);
        message.error(
          response.data?.Message || "Failed to load report configuration",
        );
      }
    } catch (error) {
      console.error("Report Config API Error:", error);
      setReportConfig(null);
      message.error("Failed to load report configuration");
    } finally {
      setConfigLoading(false);
    }
  };

  // GET CUSTOMERS

  const getCustomers = async () => {
    try {
      const response = await axios.get(`${BASE_CRM_URL}customers/GetCustomers`);

      if (response.data?.Status) {
        const data = response.data.ResultData || [];

        setCustomers(
          data
            .map((item) => ({
              value: item.id ?? item.customerid ?? item.customerId,
              label:
                item.company ??
                item.customername ??
                item.customerName ??
                item.name ??
                `Customer ${item.id}`,
            }))
            .filter((item) => item.value != null),
        );
      }
    } catch (error) {
      console.error("Customer API Error:", error);
    }
  };

  // GET LEADS

  const getLeads = async () => {
    try {
      const response = await axios.get(`${BASE_CRM_URL}leads/GetLeads`);

      if (response.data?.Status) {
        const data = response.data.ResultData || [];

        setLeads(
          data
            .map((item) => ({
              value: item.id ?? item.leadid ?? item.leadId,
              label:
                item.name ??
                item.leadname ??
                item.leadName ??
                item.company ??
                `Lead ${item.id}`,
            }))
            .filter((item) => item.value != null),
        );
      }
    } catch (error) {
      console.error("Lead API Error:", error);
    }
  };

  // const getEstimates = async () => {
  //   try {
  //     const response = await axios.get(`${BASE_CRM_URL}estimates/GetEstimates`);

  //     if (response.data?.Status) {
  //       const data = response.data.ResultData || [];

  //       setLeads(
  //         data
  //           .map((item) => ({
  //             value: item.id,
  //             label: item.Estimatenumber,
  //           }))
  //           .filter((item) => item.value != null),
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Lead API Error:", error);
  //   }
  // };

  // const getInvoice = async () => {
  //   try {
  //     const response = await axios.get(`${BASE_CRM_URL}invoice/GetInvoices`);

  //     if (response.data?.Status) {
  //       const data = response.data.ResultData || [];

  //       setLeads(
  //         data
  //           .map((item) => ({
  //             value: item.id,
  //             label: item.InvoiceNo,
  //           }))
  //           .filter((item) => item.value != null),
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Lead API Error:", error);
  //   }
  // };
  // const getProposal = async () => {
  //   try {
  //     const response = await axios.get(`${BASE_CRM_URL}invoice/GetInvoices`);

  //     if (response.data?.Status) {
  //       const data = response.data.ResultData || [];

  //       setLeads(
  //         data
  //           .map((item) => ({
  //             value: item.id,
  //             label: item.InvoiceNo,
  //           }))
  //           .filter((item) => item.value != null),
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Lead API Error:", error);
  //   }
  // };

  // const getProjects = async () => {
  //   try {
  //     const response = await axios.get(`${BASE_CRM_URL}project/GetProjects`);

  //     if (response.data?.Status) {
  //       const data = response.data.ResultData || [];

  //       setProjects(
  //         data
  //           .map((item) => ({
  //             value: item.id,
  //             label: item.name,
  //           }))
  //           .filter((item) => item.value != null),
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Lead API Error:", error);
  //   }
  // };
  // const getCreditNote = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${BASE_CRM_URL}creditnotes/GetCreditNotes`,
  //     );

  //     if (response.data?.Status) {
  //       const data = response.data.ResultData || [];

  //       setProjects(
  //         data
  //           .map((item) => ({
  //             value: item.id,
  //             label: item.name,
  //           }))
  //           .filter((item) => item.value != null),
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Lead API Error:", error);
  //   }
  // };

  const getStaff = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}staff/GetStaffDropdown`);
      const data = await response.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        setStaff(
          data.ResultData.map((item) => ({
            value: item.staffid,
            label: `${item.firstname} ${item.lastname || ""}`.trim(),
          })).filter((item) => item.value != null),
        );
      } else {
        setStaff([]);
      }
    } catch (error) {
      console.error("Error fetching staff:", error);
      setStaff([]);
    }
  };

  const getRelatedRecords = async (type) => {
    try {
      setLoading(true);

      let url = "";

      switch (type) {
        case "lead":
          url = `${BASE_CRM_URL}leads/GetLeads`;
          break;

        case "customer":
          url = `${BASE_CRM_URL}customers/GetCustomers`;
          break;

        case "project":
          url = `${BASE_CRM_URL}project/GetProjects`;
          break;

        case "invoice":
          url = `${BASE_CRM_URL}invoice/GetInvoices`;
          break;

        case "estimate":
          url = `${BASE_CRM_URL}estimates/GetEstimates`;
          break;

        case "proposal":
          url = `${BASE_CRM_URL}proposal/GetProposals`;
          break;

        case "creditNote":
          url = `${BASE_CRM_URL}creditnotes/GetCreditNotes`;
          break;

        default:
          return;
      }

      const response = await axios.get(url);

      if (response.data?.Status) {
        const data = response.data.ResultData || response.data.Data || [];

        let options = [];

        switch (type) {
          case "lead":
            options = data.map((item) => ({
              value: item.id ?? item.leadid ?? item.leadId,
              label:
                item.name ??
                item.leadname ??
                item.leadName ??
                item.company ??
                `Lead ${item.id}`,
            }));
            break;

          case "customer":
            options = data.map((item) => ({
              value: item.id ?? item.customerid ?? item.customerId,
              label:
                item.company ??
                item.customername ??
                item.customerName ??
                item.name ??
                `Customer ${item.id}`,
            }));
            break;

          case "project":
            options = data.map((item) => ({
              value: item.id,
              label: item.name,
            }));
            break;

          case "invoice":
            options = data.map((item) => ({
              value: item.id,
              label: item.InvoiceNo,
            }));
            break;

          case "estimate":
            options = data.map((item) => ({
              value: item.id,
              label: item.Estimatenumber,
            }));
            break;

          case "proposal":
            options = data.map((item) => ({
              value: item.id,
              label: item.number,
            }));
            break;

          case "creditNote":
            options = data.map((item) => ({
              value: item.id,
              label: item.credit_note_number,
            }));
            break;

          default:
            options = [];
        }

        setRelatedOptions(options.filter((item) => item.value != null));
      } else {
        setRelatedOptions([]);
      }
    } catch (error) {
      console.error("Related Record API Error:", error);
      setRelatedOptions([]);
    } finally {
      setLoading(false);
    }
  };

  // INITIAL LOAD

  useEffect(() => {
    setReportConfig(null);
    setReportData([]);
    setSearchText("");
    setFilterValues({});

    getReportConfig();
  }, [actualReportId]);

  // LOAD DROPDOWN DATA BASED ON CONFIG

  useEffect(() => {
    if (!reportConfig?.filters) return;

    const hasCustomerFilter = reportConfig.filters.some(
      (filter) => filter.key === "customerId",
    );

    const hasLeadFilter = reportConfig.filters.some(
      (filter) => filter.key === "leadId",
    );

    const hasStaffFilter = reportConfig.filters.some(
      (filter) => filter.key === "staffid",
    );

    if (hasCustomerFilter) {
      getCustomers();
    } else {
      setCustomers([]);
    }

    if (hasLeadFilter) {
      getLeads();
    } else {
      setLeads([]);
    }

    if (hasStaffFilter) {
      getStaff();
    } else {
      setStaff([]);
    }
  }, [reportConfig]);

  // HANDLE FILTER CHANGE

  const handleFilterChange = (key, value) => {
    setFilterValues((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // GET REPORT DATA

  const getReportData = async (values = filterValues) => {
    try {
      if (!reportConfig) return;

      // ----------------------------------------------
      // VALIDATE REQUIRED FILTERS
      // ----------------------------------------------
      // const requiredFilter = reportConfig.filters?.find(
      //   (filter) =>
      //     filter.required &&
      //     (values[filter.key] === undefined ||
      //       values[filter.key] === null ||
      //       values[filter.key] === ""),
      // );

      // if (requiredFilter) {
      //   console.log("enteredddddddddddd");

      //   message.warning(`${requiredFilter.label} is required`);
      //   return;
      // }

      setLoading(true);

      // ----------------------------------------------
      // BUILD API PARAMS
      // ----------------------------------------------
      const params = {
        reportId: actualReportId,
      };

      reportConfig.filters?.forEach((filter) => {
        const value = values[filter.key];

        if (value !== undefined && value !== null && value !== "") {
          if (filter.type === "date" && dayjs.isDayjs(value)) {
            params[filter.key] = value.format("YYYY-MM-DD");
          } else {
            params[filter.key] = value;
          }
        }
      });

      console.log("Report API Params:", params);

      // ----------------------------------------------
      // GET REPORT
      // ----------------------------------------------
      const response = await axios.get(`${BASE_CRM_URL}reports/GetReports`, {
        params,
      });

      if (response.data?.Status) {
        setReportData(response.data.ResultData || []);
      } else {
        setReportData([]);

        message.info(response.data?.Message || "No report data found");
      }
    } catch (error) {
      console.error("Report API Error:", error);

      message.error("Failed to load report data");

      setReportData([]);
    } finally {
      setLoading(false);
    }
  };

  // APPLY

  const handleApply = () => {
    console.log("jhghhghjgj");
    getReportData(filterValues);
  };

  // RESET

  const handleReset = () => {
    const resetValues = getDefaultFilterValues(reportConfig?.filters || []);

    setFilterValues(resetValues);
    setSearchText("");

    getReportData(resetValues);
  };

  // FORMAT TABLE VALUE

  const formatValue = (value, key) => {
    if (value === null || value === undefined || value === "") {
      return "-";
    }

    // Date fields
    if (key?.toLowerCase().includes("date")) {
      const date = dayjs(value);

      if (date.isValid()) {
        return date.format("DD-MM-YYYY");
      }
    }

    return value;
  };

  // DYNAMIC TABLE COLUMNS

  const columns =
    reportConfig?.headers?.map((header) => ({
      title: header.label,
      dataIndex: header.key,
      key: header.key,
      render: (value) => formatValue(value, header.key),
    })) || [];

  // SEARCH

  const filteredData = reportData.filter((record) => {
    if (!searchText) {
      return true;
    }

    return Object.values(record).some((value) =>
      String(value ?? "")
        .toLowerCase()
        .includes(searchText.toLowerCase()),
    );
  });

  // CONFIG LOADING

  if (configLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <Spin size="large" />
      </div>
    );
  }

  // CONFIG NOT FOUND

  if (!reportConfig) {
    return (
      <div className="py-5">
        <Empty description="Report configuration not found" />
      </div>
    );
  }

  // UI

  // ===============================
  // EXPORT REPORT TO PDF
  // ===============================
  const handleExportPDF = () => {
    if (!reportConfig || !reportConfig.headers?.length) {
      message.warning("No report configuration available");
      return;
    }

    if (!filteredData.length) {
      message.warning("No report data available to export");
      return;
    }

    try {
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      // Report title
      const pageWidth = doc.internal.pageSize.getWidth();

      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");

      doc.text(reportConfig.reportName || "Report", pageWidth / 2, 15, {
        align: "center",
      });

    
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      doc.text(
        `Generated: ${dayjs().format("DD-MM-YYYY HH:mm")}`,
        pageWidth - 14,
        22,
        {
          align: "right",
        },
      );

      // ===============================
      // APPLIED FILTERS
      // ===============================
      const appliedFilters = [];

      reportConfig.filters?.forEach((filter) => {
        const value = filterValues[filter.key];

        if (value !== undefined && value !== null && value !== "") {
          let displayValue = value;

          // Format date
          if (filter.type === "date" && dayjs.isDayjs(value)) {
            displayValue = value.format("DD-MM-YYYY");
          }

          // For Select values, display the label if required
          if (typeof displayValue === "object" && displayValue !== null) {
            displayValue = displayValue.label || displayValue.value || "";
          }

          appliedFilters.push(`${filter.label}: ${displayValue}`);
        }
      });

      // ===============================
      // FILTER TEXT
      // ===============================
      if (appliedFilters.length > 0) {
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");

        const filterText = `Filters: ${appliedFilters.join(" | ")}`;

        doc.text(filterText, pageWidth / 2, 28, {
          align: "center",
          maxWidth: pageWidth - 28,
        });
      }
      // Dynamic headers
      const tableHeaders = reportConfig.headers.map((header) => header.label);

      // Dynamic rows
      const tableRows = filteredData.map((record) =>
        reportConfig.headers.map((header) =>
          formatValue(record[header.key], header.key),
        ),
      );

      autoTable(doc, {
        startY: appliedFilters.length ? 34 : 27,

        head: [tableHeaders],
        body: tableRows,

        // Table layout
        theme: "grid",

        styles: {
          fontSize: 7,
          cellPadding: 3,
          overflow: "linebreak",
          valign: "middle",
          lineWidth: 0.2,
        },

        headStyles: {
          fontSize: 7,
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          lineWidth: 0.3,
        },

        bodyStyles: {
          fontSize: 7,
          valign: "middle",
        },

        alternateRowStyles: {
          fillColor: [248, 248, 248],
        },

        columnStyles: {
          // Example:
          // 0: { cellWidth: 25 },
          // 1: { cellWidth: 30 },
          // 2: { cellWidth: 40 },
        },

        margin: {
          top: 10,
          right: 10,
          bottom: 15,
          left: 10,
        },

        // Footer on every PDF page
        didDrawPage: () => {
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");

          doc.text(
            "Generated by Pereco | Powered by perennialcode",
            doc.internal.pageSize.getWidth() / 2,
            doc.internal.pageSize.getHeight() - 8,
            {
              align: "center",
            },
          );
        },
      });

      // Footer

      const pageCount = doc.internal.getNumberOfPages();

      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);

        doc.setFontSize(8);

        doc.text(
          `Page ${i} of ${pageCount}`,
          doc.internal.pageSize.getWidth() - 30,
          doc.internal.pageSize.getHeight() - 8,
        );
      }

      // File name
      const fileName = `${(reportConfig.reportName || "Report")
        .replace(/[^a-z0-9]/gi, "_")
        .toLowerCase()}_${dayjs().format("DD-MM-YYYY")}.pdf`;

      doc.save(fileName);

      message.success("PDF exported successfully");
    } catch (error) {
      console.error("PDF Export Error:", error);
      message.error("Failed to export PDF");
    }
  };

  // ===============================
  // EXPORT REPORT TO EXCEL
  // ===============================
  const handleExportExcel = () => {
    if (!reportConfig || !reportConfig.headers?.length) {
      message.warning("No report configuration available");
      return;
    }

    if (!filteredData.length) {
      message.warning("No report data available to export");
      return;
    }

    try {
      // Convert dynamic report data into Excel rows
      const excelData = filteredData.map((record) => {
        const row = {};

        reportConfig.headers.forEach((header) => {
          row[header.label] = formatValue(record[header.key], header.key);
        });

        return row;
      });

      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Calculate column widths
      const columnWidths = reportConfig.headers.map((header) => {
        const headerLength = header.label?.length || 10;

        const maxDataLength = Math.max(
          ...filteredData.map((record) => {
            const value = formatValue(record[header.key], header.key);

            return String(value ?? "").length;
          }),
          0,
        );

        return {
          wch: Math.min(Math.max(headerLength, maxDataLength, 10), 40),
        };
      });

      worksheet["!cols"] = columnWidths;

      // Create workbook
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

      // File name
      const fileName = `${(reportConfig.reportName || "Report")
        .replace(/[^a-z0-9]/gi, "_")
        .toLowerCase()}_${dayjs().format("DD-MM-YYYY")}.xlsx`;

      // Download
      XLSX.writeFile(workbook, fileName);

      message.success("Excel exported successfully");
    } catch (error) {
      console.error("Excel Export Error:", error);
      message.error("Failed to export Excel");
    }
  };

  return (
    <>
      <div className="page-wrapper">
        {/* {loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }}
          >
            <Spin size="large" tip="Processing..." />
          </div>
        )} */}

        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/crm/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      {reportConfig.reportName}
                    </h4>
                  </ol>
                </nav>
                {/* <p className="text-muted">Manage and add new Products</p> */}
              </div>
            </div>
            <ul className="table-top-head">
              <li className="me-2">
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleExportPDF();
                    }}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li className="me-2">
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleExportExcel();
                    }}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>{" "}
            </ul>
          </div>
          {showFilters && (
            <div className="row">
              <div className="card mb-3">
                {/* Filter Header */}
                {/* <div className="card-header d-flex align-items-center justify-content-between">
              <h5 className="mb-0">Filters</h5>

              <Button
                type="primary"
                onClick={() => setShowFilters(!showFilters)}
                icon={showFilters ? <CloseOutlined /> : <FilterOutlined />}
              >
                {showFilters ? "Close" : "Filter"}
              </Button>
            </div> */}

                {/* Filter Body */}

                <div className="card-body">
                  <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                    <div className="row g-3 align-items-end ">
                      {reportConfig.filters?.map((filter) => {
                        // DATE
                        if (filter.type === "date") {
                          return (
                            <div className="col-auto" key={filter.key}>
                              <label className="form-label d-block mb-1">
                                {filter.label}

                                {filter.required && (
                                  <span className="text-danger ms-1">*</span>
                                )}
                              </label>

                              <DatePicker
                                style={{ width: "150px", minWidth: 0 }}
                                format="DD-MM-YYYY"
                                value={filterValues[filter.key] || null}
                                onChange={(date) =>
                                  handleFilterChange(filter.key, date)
                                }
                              />
                            </div>
                          );
                        }

                        // CUSTOMER
                        if (filter.key === "customerId") {
                          return (
                            <div className="col-auto" key={filter.key}>
                              <label className="form-label d-block mb-1">
                                {filter.label}

                                {filter.required && (
                                  <span className="text-danger ms-1">*</span>
                                )}
                              </label>

                              <Select
                                style={{ width: "180px" }}
                                placeholder={`Select ${filter.label}`}
                                value={filterValues[filter.key] ?? undefined}
                                onChange={(value) =>
                                  handleFilterChange(filter.key, value)
                                }
                                options={customers}
                                allowClear
                                showSearch
                                optionFilterProp="label"
                              />
                            </div>
                          );
                        }

                        // LEAD
                        if (filter.key === "leadId") {
                          return (
                            <div className="col-auto" key={filter.key}>
                              <label className="form-label d-block mb-1">
                                {filter.label}

                                {filter.required && (
                                  <span className="text-danger ms-1">*</span>
                                )}
                              </label>

                              <Select
                                style={{ width: "180px" }}
                                placeholder={`Select ${filter.label}`}
                                value={filterValues[filter.key] ?? undefined}
                                onChange={(value) =>
                                  handleFilterChange(filter.key, value)
                                }
                                options={leads}
                                allowClear
                                showSearch
                                optionFilterProp="label"
                              />
                            </div>
                          );
                        }
                        if (filter.key === "rel_type") {
                          return (
                            <div className="col-auto" key={filter.key}>
                              <label className="form-label d-block mb-1">
                                {filter.label}

                                {filter.required && (
                                  <span className="text-danger ms-1">*</span>
                                )}
                              </label>

                              <Select
                                style={{ width: "180px" }}
                                placeholder={`Select ${filter.label}`}
                                value={filterValues[filter.key] ?? undefined}
                                onChange={(value) => {
                                  handleFilterChange("rel_type", value);

                                  // Clear selected Related Record
                                  handleFilterChange("rel_id", undefined);

                                  // Load records based on selected type
                                  if (value) {
                                    getRelatedRecords(value);
                                  }
                                }}
                                options={RELATED_TO_OPTIONS}
                                allowClear
                                showSearch
                                optionFilterProp="label"
                              />
                            </div>
                          );
                        }
                        if (filter.key === "rel_id") {
                          return (
                            <div className="col-auto" key={filter.key}>
                              <label className="form-label d-block mb-1">
                                {filter.label}

                                {filter.required && (
                                  <span className="text-danger ms-1">*</span>
                                )}
                              </label>

                              <Select
                                style={{ width: "180px" }}
                                placeholder={`Select ${filter.label}`}
                                value={filterValues[filter.key] ?? undefined}
                                onChange={(value) =>
                                  handleFilterChange("rel_id", value)
                                }
                                options={relatedOptions}
                                allowClear
                                showSearch
                                optionFilterProp="label"
                                disabled={!filterValues.rel_type}
                              />
                            </div>
                          );
                        }

                        if (filter.key === "staffid") {
                          return (
                            <div className="col-auto" key={filter.key}>
                              <label className="form-label d-block mb-1">
                                {filter.label}

                                {filter.required && (
                                  <span className="text-danger ms-1">*</span>
                                )}
                              </label>

                              <Select
                                style={{ width: "180px" }}
                                placeholder={`Select ${filter.label}`}
                                value={filterValues[filter.key] ?? undefined}
                                onChange={(value) =>
                                  handleFilterChange(filter.key, value)
                                }
                                options={staff}
                                allowClear
                                showSearch
                                optionFilterProp="label"
                              />
                            </div>
                          );
                        }

                        // if (filter.key === "estimateId") {
                        //   return (
                        //     <div className="col-auto" key={filter.key}>
                        //       <label className="form-label d-block mb-1">
                        //         {filter.label}

                        //         {filter.required && (
                        //           <span className="text-danger ms-1">*</span>
                        //         )}
                        //       </label>

                        //       <Select
                        //         style={{ width: "180px" }}
                        //         placeholder={`Select ${filter.label}`}
                        //         value={filterValues[filter.key] ?? undefined}
                        //         onChange={(value) =>
                        //           handleFilterChange(filter.key, value)
                        //         }
                        //         options={estimates}
                        //         allowClear
                        //         showSearch
                        //         optionFilterProp="label"
                        //       />
                        //     </div>
                        //   );
                        // }
                        // if (filter.key === "invoiceId") {
                        //   return (
                        //     <div className="col-auto" key={filter.key}>
                        //       <label className="form-label d-block mb-1">
                        //         {filter.label}

                        //         {filter.required && (
                        //           <span className="text-danger ms-1">*</span>
                        //         )}
                        //       </label>

                        //       <Select
                        //         style={{ width: "180px" }}
                        //         placeholder={`Select ${filter.label}`}
                        //         value={filterValues[filter.key] ?? undefined}
                        //         onChange={(value) =>
                        //           handleFilterChange(filter.key, value)
                        //         }
                        //         options={invoice}
                        //         allowClear
                        //         showSearch
                        //         optionFilterProp="label"
                        //       />
                        //     </div>
                        //   );
                        // }
                        // if (filter.key === "proposalId") {
                        //   return (
                        //     <div className="col-auto" key={filter.key}>
                        //       <label className="form-label d-block mb-1">
                        //         {filter.label}

                        //         {filter.required && (
                        //           <span className="text-danger ms-1">*</span>
                        //         )}
                        //       </label>

                        //       <Select
                        //         style={{ width: "180px" }}
                        //         placeholder={`Select ${filter.label}`}
                        //         value={filterValues[filter.key] ?? undefined}
                        //         onChange={(value) =>
                        //           handleFilterChange(filter.key, value)
                        //         }
                        //         options={proposal}
                        //         allowClear
                        //         showSearch
                        //         optionFilterProp="label"
                        //       />
                        //     </div>
                        //   );
                        // }

                        // GENERIC SELECT
                        if (filter.type === "select") {
                          return (
                            <div className="col-auto" key={filter.key}>
                              <label className="form-label d-block mb-1">
                                {filter.label}

                                {filter.required && (
                                  <span className="text-danger ms-1">*</span>
                                )}
                              </label>

                              <Select
                                style={{ width: "180px" }}
                                placeholder={`Select ${filter.label}`}
                                value={filterValues[filter.key] ?? undefined}
                                onChange={(value) =>
                                  handleFilterChange(filter.key, value)
                                }
                                allowClear
                                showSearch
                                optionFilterProp="label"
                              />
                            </div>
                          );
                        }

                        // TEXT INPUT
                        return (
                          <div className="col-auto" key={filter.key}>
                            <label className="form-label d-block mb-1">
                              {filter.label}

                              {filter.required && (
                                <span className="text-danger ms-1">*</span>
                              )}
                            </label>

                            <Input
                              style={{ width: "180px" }}
                              placeholder={`Enter ${filter.label}`}
                              value={filterValues[filter.key] || ""}
                              onChange={(e) =>
                                handleFilterChange(filter.key, e.target.value)
                              }
                            />
                          </div>
                        );
                      })}

                      {/* APPLY / RESET */}
                      <div className="col-auto d-flex gap-2">
                        <Button
                          type="primary"
                          title="Apply"
                          onClick={handleApply}
                          loading={loading}
                          icon={<CheckOutlined />}
                        />

                        <Button
                          title="refersh"
                          onClick={() => {
                            handleReset();
                          }}
                          icon={<ReloadOutlined />}
                          disabled={loading}
                        />

                        <Button
                          title="close"
                          onClick={() => setShowFilters(!showFilters)}
                          icon={<CloseOutlined />}
                        ></Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="row">
            {/* /product list */}
            <div className="card table-list-card ">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <div className="search-set "></div>
                <div className="d-flex align-items-end justify-content-between">
                  <Button
                    title="OpenFilter"
                    type="primary"
                    icon={<FilterOutlined />}
                    onClick={() => setShowFilters(true)}
                  ></Button>
                </div>
              </div>

              <div className="card-body p-0">
                <div className="table-responsive">
                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "250px", // adjust height if needed
                      }}
                    >
                      <Spin size="large" />
                    </div>
                  ) : (
                    <Table columns={columns} dataSource={filteredData} />
                  )}
                </div>
              </div>
            </div>
            {/* /product list */}
          </div>

          <CommonFooter />
        </div>
      </div>
    </>
  );
};

export default Reports;
